import React from 'react';

interface Props {
  to: string;
  className?: string;
  children?: string;
}

function ExternalLink({ to, className, children }: Props) {
  return (
    <a className={className} href={to}>{children}</a>
  );
}

export default ExternalLink;
